export default __webpack_public_path__ + "static/media/filter.4d0f6980.svg";